module.exports = __webpack_public_path__ + "static/8-dfc6ecaa69cbb4c7f0986acb21735e62.jpeg";